import Select from 'react-select';
import { ErrorMessage } from 'formik';
import { useEffect } from 'react';

export const RunTestBulkPageTypeSelect = ({ onChange, name, value, options, defaultValue }: any) => {
  useEffect(() => {
    if (!value && defaultValue) {
      onChange(defaultValue);
    }
  }, [value, defaultValue, onChange]);

  return (
    <>
      <Select
        required
        menuPosition={'fixed'}
        isSearchable={false}
        placeholder="Select page type"
        options={options}
        styles={{
          control: (base) => ({
            ...base,
            height: 60,
            minHeight: 60,
            borderRadius: 7
          })
        }}
        name={name}
        onChange={onChange}
        value={value}
      />
      <ErrorMessage name={name} component={'p'} className={'form-control-error-message'} />
    </>
  );
};

const labels = ['OTK', 'Checklist', 'Defect', 'Content', 'GNB', 'Footer'];

export const runTestBulkOptions = labels.map((label) => ({
  value: label.toLowerCase(),
  label: label
}));

export const RunTestBulkFilterSelect = ({ onChange, name, options, isDisabled, value }: any) => {
  return (
    <>
      <Select
        name={name}
        placeholder="Select filter"
        menuPosition={'fixed'}
        isSearchable={false}
        isClearable={true}
        isMulti={true}
        isDisabled={isDisabled}
        styles={{
          container: (base) => ({
            ...base,
            width: '200px',
            height: 60,
            minHeight: 60
          }),
          control: (base) => ({
            ...base,
            height: 60,
            minHeight: 60,
            border: '1px solid #808080',
            borderRadius: 7
          }),
          indicatorSeparator: (base) => ({
            ...base,
            display: 'none'
          }),
          dropdownIndicator: (base) => ({
            ...base,
            display: 'none'
          })
        }}
        options={options}
        onChange={onChange}
        value={value}
      />
      <ErrorMessage name={name} component={'p'} className={'form-control-error-message'} />
    </>
  );
};
